// extracted by mini-css-extract-plugin
module.exports = {"stats_card":"cardsStats_stats_card__3mLsG","stats_cards__group":"cardsStats_stats_cards__group__1ntbJ"};